/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.1.0
 * @since 1.1.0
 */

import {
    EExpensesAnalyzerField,
} from '../../../../../pages/PageExpensesAnalyzer/components/ExpensesAnalyzerTable/types/expensesAnalyzerTableTypes';
import { colors } from '../../../../../theme';

export const MapChartCategoryNameToColor = {
    [EExpensesAnalyzerField.CHARGES]: colors.chartCostsOneTimeCharges,
    [EExpensesAnalyzerField.MONTH_CHARGE_SRLS]: colors.chartCostsOtherRecurringCharges,
    [EExpensesAnalyzerField.MONTH_CHARGE_RTPL]: colors.chartCostsRecurringChargesForRatePlan,
    [EExpensesAnalyzerField.AMOUNT_LOCAL_MACRO]: colors.chartCostsTrafficChargesAtHomeMacroRegionAndNotInHomeRegion,
    [EExpensesAnalyzerField.AMOUNT_LOCAL]: colors.chartCostsTrafficChargesAtHomeRegion,
    [EExpensesAnalyzerField.AMOUNT_COUNTRY_ROAMING]: colors.chartCostsTrafficChargesAtOutHomeMacroRegion,
    [EExpensesAnalyzerField.AMOUNT_ROAMING]: colors.chartCostsTrafficChargesAtRoaming,
};
